import {addItemToCart, initializeQuantityInput} from "./QuickBuy";

export default () => {
    const customProductPage = document.querySelector('.customProductPage');
    if (!customProductPage) return;

    initializeProductGallery();
    initializeProductQuantity();
    initializeAddToCartAjax();
    initializeProductCustomPrice();
    readMoreBtn();
}

const initializeProductGallery = () => {
    const customProductGallery = document.querySelector('.productCustomGallery');
    if (!customProductGallery) return;

    const slider = new window.splide(customProductGallery, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        pagination: true,
        arrows: false,
        lazyLoad: 'nearby',
        classes: {
            pagination: 'splide__pagination splide__pagination--dark',
        },
        gap: '16px',
        mediaQuery: 'min',
        breakpoints: {
            993: {
                destroy: true
            }
        }
    });

    slider.on('overflow', function (isOverflow) {
        slider.options = {
            pagination: isOverflow,
            drag: isOverflow,
        };
    });

    slider.mount();

    let lightbox = new window.lightbox({
        elements: '.lightBoxRun'
    });
}

const initializeProductQuantity = () => {
    initializeQuantityInput(document.querySelector('.customProductPage__summary form .quantity'));
}

const initializeAddToCartAjax = () => {
    const form = document.querySelector('.customProductPage__summary form');
    if (!form) return;
    const addToCartButton = form.querySelector('.single_add_to_cart_button');

    if (!addToCartButton) return;
    addToCartButton.addEventListener('click', async e => {
        e.preventDefault();
        let product_id = addToCartButton.value;
        const quantity = form.querySelector('input[name="quantity"]').value ?? 1;
        const variationId = form.querySelector('input[name="variation_id"]');
        if (variationId) {
            if (variationId.value === '0') return;
            product_id = variationId.value;
        }
        addToCartButton.classList.add('loading');
        await addItemToCart(product_id, parseInt(quantity));
        addToCartButton.classList.remove('loading');
    });
}

const initializeProductCustomPrice = () => {
    const form = document.querySelector('.customProductPage__summary form');
    if(!form) return;
    const addToCartButton = form.querySelector('.single_add_to_cart_button');
    jQuery(form).on('found_variation', (event, variation) => {
        setTimeout(() => {
            let priceElement = addToCartButton.querySelector(':scope > span');
            if(!priceElement) {
                createPriceContainer(addToCartButton);
                priceElement = addToCartButton.querySelector(':scope > span')
            }
            priceElement.innerHTML = variation.price_html;
        }, 300);
    })
}

const createPriceContainer = (addToCartButton) => {
    addToCartButton.innerHTML = `${addToCartButton.innerHTML} - <span></span>`;
}

const readMoreBtn = () => {
    const description = document.getElementById('short-description-content');
    const showMoreBtn = document.getElementById('show-more-btn');

    if (description && showMoreBtn) {
        const maxLength = 300;
        if (description.innerText.length > maxLength) {
            const originalText = description.innerHTML;
            const truncatedText = originalText.substring(0, maxLength) + '...';

            description.innerHTML = truncatedText;
            showMoreBtn.style.display = 'inline';

            showMoreBtn.addEventListener('click', () => {
                description.innerHTML = originalText;
                showMoreBtn.style.display = 'none';
            });
        }
    }
}